"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_DEFAULT_CONFIG = exports.INTERNAL_MIN_NODE_COUNT = exports.INTERNAL_DEV = void 0;
// This file is auto-generated by tools/scripts/gen-internal-dev.mjs
exports.INTERNAL_DEV = [
    'https://167.114.17.205:443',
    'https://167.114.17.203:443',
    'https://158.69.34.227:443',
];
exports.INTERNAL_MIN_NODE_COUNT = 3;
exports.INTERNAL_DEFAULT_CONFIG = {
    alertWhenUnauthorized: false,
    minNodeCount: 3,
    debug: true,
    bootstrapUrls: [
        'https://167.114.17.205:443',
        'https://167.114.17.203:443',
        'https://158.69.34.227:443',
    ],
    litNetwork: 'internalDev',
    connectTimeout: 20000,
};
//# sourceMappingURL=autogen_internal.js.map